const MAdmin = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  },
  {
    title: 'Accounts',
    is_heading: true,
    is_active: false,
    link: {
      name: 'admin.accounts'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Users',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.accounts.users'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-user-visor',
    active_icon: 'fad fa-user-visor'
  }
]

const MAdminMaintenances = [
  {
    title: 'Maintenances',
    is_heading: true,
    is_active: false,
    link: {
      name: 'admin.maintenances'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Document Types',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.maintenances.document-types'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-file-circle-question',
    active_icon: 'fad fa-file-circle-question'
  },
  {
    title: 'Activities',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.maintenances.activities'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-list-check',
    active_icon: 'fad fa-list-check'
  },
  {
    title: 'Product Groups',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.maintenances.product-groups'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cube',
    active_icon: 'fad fa-cube'
  },
  {
    title: 'Product Categories',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.maintenances.product-categories'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cubes',
    active_icon: 'fad fa-cubes'
  },
  {
    title: 'Products',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.maintenances.products'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cubes-stacked',
    active_icon: 'fad fa-cubes-stacked'
  },
  {
    title: 'Customers',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.maintenances.sync-customers'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-user-tie-hair',
    active_icon: 'fad fa-user-tie-hair'
  }
]

const MAdminLocations = [
  {
    title: 'Locations',
    is_heading: true,
    is_active: false,
    link: {
      name: 'admin.locations'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Teams',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.locations.teams'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-screen-users',
    active_icon: 'fad fa-screen-users'
  },
  {
    title: 'Areas',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.locations.areas'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-map-pin',
    active_icon: 'fad fa-map-pin'
  },
  {
    title: 'Clusters',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.locations.clusters'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-map',
    active_icon: 'fad fa-map'
  },
  {
    title: 'Regions',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.locations.regions'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-earth-asia',
    active_icon: 'fad fa-earth-asia'
  },
  {
    title: 'Provinces',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.locations.provinces'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-map-location-dot',
    active_icon: 'fad fa-map-location-dot'
  },
  {
    title: 'Municipalities',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.locations.municipalities'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-mountain-city',
    active_icon: 'fad fa-mountain-city'
  },
  {
    title: 'Barangays',
    is_heading: false,
    is_active: false,
    link: {
      name: 'admin.locations.barangays'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-archway',
    active_icon: 'fad fa-archway'
  }
]

export default MAdmin.concat(
  MAdminMaintenances,
  MAdminLocations
)
